import { Board, ImportTable } from '@/Components/Partials';
import { BrandArchivedContainer } from '@/entities/Brand/ui';
import { Api } from '@/Services/api';
import { Request } from '@/Types';

import { StationTab } from '../../../lib/StationTab';

export const Products: StationTab = ({ station, filters, permissions }) => {
    const getTable = (query?: Request.All) => {
        if (!station) return;

        return Api.stations().getProducts(station.id, query);
    };

    const postTable = (ids: number[]) => {
        if (!station) return;

        return Api.stations().updateProducts(station.id, ids);
    };

    return (
        <Board.Line>
            <Board.Item>
                <ImportTable
                    headers={['UDI', 'Name', 'Brand'] as const}
                    get={getTable}
                    post={postTable}
                    getId={(item) => item.id}
                    itemRender={(column, item) => {
                        switch (column) {
                            case 'UDI':
                                return item.udi;
                            case 'Name':
                                return item.name;
                            case 'Brand':
                                return <BrandArchivedContainer brand={item.brand}>{item.brand.name}</BrandArchivedContainer>;
                        }
                    }}
                    getDefault={(item) => item.is_connected}
                    getData={(data) => data.products}
                    filters={filters}
                    edit={!permissions?.admin}
                />
            </Board.Item>
        </Board.Line>
    );
};
